type OthersDraftProps = {
  kind: "others";
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  onSubmit: () => void;
};

type DigitalDraftProps = {
  kind: "digital";
  value: string;
  onChange: (value: string) => void;
  alreadySaved: boolean;
  disabled?: boolean;
  onSubmit: () => void;
};

type Props = OthersDraftProps | DigitalDraftProps;

const DRAFT_FIELD_CLASS =
  "mb-1.5 w-full appearance-none rounded-md border border-solid border-slate-200 bg-white px-2 py-1.5 text-xs text-slate-800 shadow-none outline-none placeholder:text-slate-400 focus:border-orange-400 focus:outline-none focus:ring-1 focus:ring-orange-400/30";

export default function KeyLocationTableSpecialDraft(props: Props) {
  const disabled = props.disabled;
  const canSubmit =
    props.kind === "others"
      ? props.value.trim() !== ""
      : props.alreadySaved || props.value.trim() !== "";

  return (
    <div className="border-t border-slate-100 bg-slate-50 px-2.5 py-2">
      <p className="mb-1 text-[10px] font-semibold uppercase tracking-wide text-slate-500">
        {props.kind === "others"
          ? "Observação (obrigatória)"
          : props.alreadySaved
            ? "Senha da chave digital"
            : "Senha (obrigatória)"}
      </p>
      {props.kind === "others" ? (
        <textarea
          rows={2}
          value={props.value}
          onChange={(event) => props.onChange(event.target.value)}
          placeholder="Descreva onde estão as chaves"
          className={`${DRAFT_FIELD_CLASS} resize-none`}
        />
      ) : (
        <input
          type="text"
          autoComplete="off"
          value={props.value}
          onChange={(event) => props.onChange(event.target.value)}
          placeholder="Informe a senha de acesso"
          className={DRAFT_FIELD_CLASS}
        />
      )}
      <button
        type="button"
        disabled={disabled || !canSubmit}
        onClick={props.onSubmit}
        className="w-full rounded-md bg-orange-500 py-1 text-[11px] font-semibold text-white transition hover:bg-orange-600 disabled:opacity-50"
      >
        Salvar
      </button>
    </div>
  );
}
